import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import Products from "@/components/Products";
import WhyZeltaa from "@/components/WhyZeltaa";
import Footer from "@/components/Footer";


export const metadata = {
  title: "Zeltaa | Intelligence Infrastructure for Better Healthcare",
  description:
    "Zeltaa is building the intelligence infrastructure that helps healthcare providers deliver faster diagnoses and better patient outcomes.",
  keywords: [
    "AI healthcare infrastructure",
    "Radiology AI",
    "Radiology workflow automation",
    "AI reporting platform",
    "Healthcare AI software",
    "Diagnostic center automation",
    "Clinical workflow automation",
    "Radiology productivity tools",
    "Medical AI platform",
  ],
  alternates: {
    canonical: "https://zeltaa.com",
  },
  openGraph: {
    image: "/og-image.png",
  },
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Zeltaa",
  url: "https://zeltaa.com",
  logo: "https://zeltaa.com/logo.png",
  description:
    "Zeltaa is building the intelligence infrastructure that helps healthcare providers deliver faster diagnoses and better patient outcomes. Our AI-powered systems augment clinical workflows, reduce operational bottlenecks, and enable healthcare organizations to scale expertise without increasing complexity.",
  foundingDate: "2025",
  industry: "Healthcare AI Technology",
  sameAs: ["https://zeltaa.com/"],
};

export default function Landing() {
  return (
    <main data-testid="zeltaa-landing">
      <Navbar />
      <Hero />
      <TrustStrip />
      <Products />
      <WhyZeltaa />
      <Footer />
    </main>
  );
}
